import {
  Button,
  Grid,
  FormControl,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Loader from "../../layout/Loader";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import { fetchList } from "../../apis/services/CommonApiService";
import { DatePicker } from "@mui/x-date-pickers";
import HeatmapChart from "./BookingPatternComponent/HeatmapChart";
import { bookingPatternMonthsDatasSuccess, bookingPatternSearchFiltersSuccess } from "../../Reducer/revenueGenerationSlice";
import { convertToKeyValue, getMinDateForLimited } from "../../utils/helper";
import { connect } from "react-redux";

const BookingPattern = (props) => {
  const {searchFilters,
    monthsDatas,
    searchFilterSucces,
    setMonthDatas} = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const setSearchFilters = (props) => {
    searchFilterSucces(convertToKeyValue(props));
  };

const getReservationPrintList = async () => {
  if(monthsDatas?.length === 0){
    setLoading(true);
  }
  const result = await fetchList(
    ApiEndPoints.GET_RESERVATIONS +
      `?page_no=${1}&items_per_page=${100000000}&start_date=${
        searchFilters.startDate
      }&end_date=${searchFilters.endDate}`
  );

  if (result?.status === 200) {
    const leadTimeGroups = [
      { label: "0-7", from: 0, to: 7 },
      { label: "8-15", from: 8, to: 15 },
      { label: "16-30", from: 16, to: 30 },
      { label: "31-60", from: 31, to: 60 },
      { label: "61-90", from: 61, to: 90 },
      { label: "90+", from: 91, to: Infinity },
    ];

    const nightGroups = [
      { label: "0-3", from: 0, to: 3 },
      { label: "4-7", from: 4, to: 7 },
      { label: "7+", from: 8, to: Infinity },
    ];

    const data = result?.data?.rows?.map((element) => {
      const bookingDate = moment(element?.booking_date, "YYYY-MM-DD");
      const checkinDate = moment(element?.checkin_date, "YYYY-MM-DD");

      return {
        checkinDate, // add this for filtering later
        month: checkinDate.month() + 1,
        year: checkinDate.year(),
        timeAgo: checkinDate.diff(bookingDate, "days"),
        night: element?.no_of_days,
      };
    }) || [];

    // Build list of month/year pairs in search range
    const startDate = moment(searchFilters?.startDate, "YYYY-MM-DD");
    const endDate = moment(searchFilters?.endDate, "YYYY-MM-DD");

    const monthYearPairs = [];
    let temp = startDate.clone();
    while (temp.isSameOrBefore(endDate, "month")) {
      monthYearPairs.push({ year: temp.year(), month: temp.month() + 1 });
      temp.add(1, "month");
    }

    const monthsData = monthYearPairs.map(({ year, month }) => {
      const monthBookings = data.filter(
        (d) => d.checkinDate.year() === year && d.checkinDate.month() + 1 === month
      );

      const leadTimeData = leadTimeGroups.map((lt) => {
        const filteredByLeadTime = monthBookings.filter(
          (d) => d.timeAgo >= lt.from && d.timeAgo <= lt.to
        );

        const values = nightGroups.map((ng) =>
          filteredByLeadTime.filter(
            (d) => d.night >= ng.from && d.night <= ng.to
          ).length
        );

        return {
          leadTimeGroup: lt.label,
          values,
        };
      });

      return {
        year,
        month,
        data: leadTimeData,
      };
    });
    setMonthDatas(monthsData);
    setLoading(false);
  } else {
    setLoading(false);
  }
};


  useEffect(()=>{
    getReservationPrintList();
  },[]);

  //   const monthsData = [
  //   {
  //     month: 1,
  //     data: [
  //       { leadTimeGroup: '0-7', values: [100, 10, 0] },
  //       { leadTimeGroup: '8-15', values: [27, 10, 0] },
  //       { leadTimeGroup: '16-30', values: [28, 10, 0] },
  //       { leadTimeGroup: '31-60', values: [11, 8, 1] },
  //       { leadTimeGroup: '61-90', values: [4, 3, 1] },
  //       { leadTimeGroup: '90+', values: [1, 0, 1] }
  //     ]
  //   },
  //   // ... repeat for months 2 to 12
  // ];

  return (
    <div>
      <Grid container>
        {loading && <Loader />}

        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          style={{ marginTop: "5px", marginBottom: "20px" }}
        >
          <Grid item xs={12} sm={6} md={4} style={{ paddingTop: "0px" }}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("Start Date")}
              </Typography>
              <DatePicker
                format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
                value={moment(searchFilters.startDate, "YYYY-MM-DD")}
                onChange={(e) => {
                  setSearchFilters({
                    startDate: moment(e).format("YYYY-MM-DD"),
                  });
                }}
                 minDate={getMinDateForLimited()}
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4} style={{ paddingTop: "0px" }}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("End Date")}
              </Typography>
              <DatePicker
                format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
                minDate={moment(searchFilters.startDate, "YYYY-MM-DD")} // Correct way to set minDate
                value={moment(searchFilters.endDate, "YYYY-MM-DD")}
                onChange={(e) => {
                  setSearchFilters({
                    endDate: moment(e).format("YYYY-MM-DD"),
                  });
                }}
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item lg={4} md={4} style={{ paddingTop: "0px" }}>
            <div
              style={{
                height: "100%",
                marginTop: "40px",
                display: "flex",
                gap: "10px",
              }}
            >
              <Button
                size="large"
                variant="contained"
                disableElevation
                type="submit"
                color="primary"
                className="comman-button"
                onClick={() => {
                  setLoading(true);
                  getReservationPrintList()}}
              >
                {t("Submit")}
              </Button>
            </div>
          </Grid>
        </Grid>

        
           <Grid container rowSpacing={4} columnSpacing={2}>
            
           
              {monthsDatas.map((monthData, index) => (
                <Grid item xs={12} md={6} lg={4}>
                <HeatmapChart
                  key={index}
                  chartKey={index}
                  data={monthData.data}
                  month={monthData.month}
                  year = {monthData?.year}
                />
                </Grid>
              ))}
            </Grid>
        </Grid>
      
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    searchFilters: state.revenueGeneration.bookingPatternSearchFilters,
    monthsDatas: state.revenueGeneration.bookingPatternMonthsDatas,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    searchFilterSucces: (data) =>
      dispatch(bookingPatternSearchFiltersSuccess(data)),
    setMonthDatas: (data) =>
      dispatch(bookingPatternMonthsDatasSuccess(data)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingPattern);
